export const styles = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    '& > div': {
      marginBottom: 20,
    },
  },
  titleRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    cursor: 'pointer',
    userSelect: 'none',
  },
  title: {
    fontSize: 20,
    fontFamily: "'Proxima Nova Alt', sans-serif",
    color: '#011533',
    fontWeight: '700',
  },
  arrowButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: 10,
    transition: 'transform 0.3s ease-in-out',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    marginBottom: '0 !important',
    '& thead th': {
      fontSize: 16,
      fontFamily: "'Proxima Nova Alt', sans-serif",
      color: '#707087',
      fontWeight: '500',
      textAlign: 'left',
      padding: '8px 12px !important',
    },
    '& tbody td': {
      fontSize: 16,
      fontFamily: "'Proxima Nova Alt', sans-serif",
      color: '#011533',
      padding: '8px 12px !important',
      borderBottom: '1px solid #F0F0F5',
    },
  },
  link: {
    fontFamily: "'Proxima Nova Alt', sans-serif !important",
    fontSize: '16px !important',
    fontWeight: '700',
    color: '#011533',
    cursor: 'pointer',
    textDecoration: 'underline',
  },
  deleteButton: {
    cursor: 'pointer',
    border: 'none',
    background: 'none',
    padding: 4,
    '&:hover': {
      opacity: 0.7,
    },
  },
  emptyState: {
    fontSize: 18,
    fontFamily: "'Proxima Nova Alt', sans-serif",
    color: '#707087',
    textAlign: 'center',
  },
  modalContainer: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    paddingTop: 30,
  },
  modalIcon: {
    alignSelf: 'center',
  },
  modalTitle: {
    fontSize: 24,
    fontFamily: "'Proxima Nova Alt', sans-serif",
    color: 'black',
    fontWeight: '700',
    textAlign: 'center',
    marginBottom: 20,
    width: '80%',
  },
  modalButtons: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 20,
    marginBottom: 20,
    width: '100%',
  },
}
